import { getActivity } from './activity-data'; // Adjust the import path

export async function getBooking(id) {
  const bookings = await getBookings();
  return bookings.find((order) => order.id.toString() === id);
}

export async function getRecentBookings() {
  const bookings = await getBookings();
  return bookings.slice(0, 10);
}

export async function getBookings() {
  return [
    {
      id: 3000,
      referenceNumber: 'BK-20240509-3000',
      url: '/bookings/3000',
      date: 'May 9, 2024',
      status: 'confirmed',
      amount: {
        usd: '$80.00',
        cad: '$109.47',
        fee: '$3.28',
        net: '$106.19',
      },
      payment: {
        transactionId: 'ch_2HLf8DfYJ0Db7asfCC5T546TY',
        card: {
          number: '1254',
          type: 'American Express',
          expiry: '01 / 2025',
        },
      },
      customer: {
        userId: null, // null indicates a guest booking
        name: 'Leslie Alexander',
        email: 'leslie.alexander@example.com',
        mobile: '+973 12341234',
        address: '123 Main St. Toronto, ON',
        country: 'Canada',
        countryFlagUrl: '/flags/ca.svg',
        registered: false, // false for guest bookings
      },
      activity: await getActivity('1000'),
    },
    {
      id: 3001,
      referenceNumber: 'BK-20240509-3001',
      url: '/bookings/3001',
      date: 'May 10, 2024',
      status: 'canceled',
      amount: {
        usd: '$150.00',
        cad: '$205.47',
        fee: '$5.28',
        net: '$200.19',
      },
      payment: {
        transactionId: 'ch_2HLf8DfYJ0Db7asfCC5T546TZ',
        card: {
          number: '4321',
          type: 'Visa',
          expiry: '12 / 2026',
        },
      },
      customer: {
        userId: 2000, // Indicates a registered user
        name: 'John Doe',
        email: 'john.doe@example.com',
        mobile: '+971 987654321',
        address: '456 Elm St. New York, NY',
        country: 'United States',
        countryFlagUrl: '/flags/us.svg',
        registered: true, // true for registered users
      },
      activity: await getActivity('1001'),
    },
    // Add more bookings as needed
  ];
}
